import useChatRestClient from '@/Api/ChatRestClient';
import {useMutation} from '@tanstack/react-query';

export default function useBookStudentPreferredSlot(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const ChatRestClient = useChatRestClient();
  type MentorCallsResponse = {
    success: boolean;
    [key: string]: any;
  };

  const mutation = useMutation<MentorCallsResponse>(
    async payload => {
      const response = await ChatRestClient.post(
        'subscription/v1/book-student-preferred-slot',
        payload,
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess && data?.success) {
          handleOnSuccess(data);
        } else if (handleOnError) {
          handleOnError(data);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
